import * as React from 'react';
import { Box } from '~shared/components/Box';
import { UseIconProps, useIcon } from '../../useIcon';
import { IconMultipleChoiceSvg } from './IconMultipleChoiceSvg';

export type IconMultipleChoiceProps = UseIconProps;

export function IconMultipleChoice(props: IconMultipleChoiceProps) {
  const iconProps = useIcon({ size: 'micro', ...props });
  return <Box tagName={IconMultipleChoiceSvg} {...iconProps} />;
}
